<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex
          v-if="permissions.client_sadad == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/ClientSadad')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              سداد العملاء
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.importer_sadad == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/ImporterSadad')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              سداد الموردين
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.client_khasm == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/ClientKhasm')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              خصم العملاء
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.khazina_deposit == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/Deposit')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              ايداع مبلغ
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.khazina_withdrew == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/Withdrew')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              سحب مبلغ
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.khazina_transfer == 1 || user.type == 1"
          xs12
          sm6
          md4
        >
          <v-card
            @click="$router.push('/Masrofat')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              مصروفات
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.masrofat == 1 || user.type == 1" xs12 sm6 md4>
          <v-card
            @click="$router.push('/Ohda')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              عهدة
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.ohda == 1 || user.type == 1" xs12 sm6 md6>
          <v-card
            @click="$router.push('/KhaznaTransfer')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              تحويل من خزينة اخري
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
